import {
  GetPreferencesAddressModalQuery,
  GetPreferencesAddressModalQueryVariables
} from '@data/__generated__/types.main'
import isServerSide from '@helpers/misc/isServerSide'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery, useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function usePreferenceAddressModal() {
  const websiteId = useWebsiteId()
  const result = useQuery<
    GetPreferencesAddressModalQuery,
    GetPreferencesAddressModalQueryVariables
  >({
    query: gql`
      query getPreferencesAddressModal($websiteId: ID) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          showAddressModal
        }
      }
    `,
    variables: {websiteId},
    partial: true,
    omit: isServerSide() || !websiteId
  })

  const mutate = useMutate()

  const submitAddressPreference = async showAddressModal => {
    await mutate({
      mutation: gql`
        mutation setAddressPreference($websiteId: ID, $showAddressModal: Boolean) {
          setUserPreferences(websiteId: $websiteId, showAddressModal: $showAddressModal) {
            _id
            showAddressModal
          }
        }
      `,
      variables: {websiteId, showAddressModal},
      refetchQueries: ['getPreferencesAddressModal']
    })
  }

  let showAddressModal = !!result?.data?.preferences?.showAddressModal

  if (result?.data?.preferences?.showAddressModal === null) {
    showAddressModal = true
  }

  return {
    showAddressModal,
    submitAddressPreference
  }
}

export const withAddressModalPreferences = (
  Component: React.ComponentClass<{
    submitAddressPreference?: (boolean?) => void
  }>
) => {
  // eslint-disable-next-line react/display-name
  return props => {
    const {submitAddressPreference} = usePreferenceAddressModal()

    return <Component {...props} submitAddressPreference={submitAddressPreference} />
  }
}
